import { Check } from "lucide-react";
import { FIT_OPTIONS } from "../constants";

// ═══════════════════════════════════════════════════════════════════════════
// STEP: Fit Tercihi
// ═══════════════════════════════════════════════════════════════════════════
export const FitPrefStep = ({ profile, onSelect, copy, accent }) => (
    <div className="space-y-6" data-testid="fms-step-fit">
        <div>
            <h3 className="text-[24px] font-bold text-foreground tracking-tight leading-tight">
                {copy.fitTitle || "Bu ürünü nasıl giymek istersin?"}
            </h3>
            <p className="text-[13.5px] text-muted-foreground mt-2 leading-relaxed">
                {copy.fitDesc || "Fit tercihin, aynı vücut için farklı beden önerir. Beğendiğini seç."}
            </p>
        </div>
        <div className="space-y-2.5">
            {FIT_OPTIONS.map((opt, i) => {
                const selected = profile.fit === opt.value;
                return (
                    <button
                        key={opt.value}
                        type="button"
                        onClick={() => onSelect(opt.value)}
                        className="w-full h-20 flex items-center justify-between gap-4 rounded-lg border px-4 py-3 text-left transition-all sayz-fms-chip hover:border-foreground/30 hover:-translate-y-[1px] hover:shadow-[0_2px_10px_-2px_rgba(0,0,0,0.06)] active:scale-[0.99]"
                        style={{
                            ...(selected
                                ? {
                                      borderColor: accent,
                                      background: `color-mix(in srgb, ${accent} 5%, transparent)`,
                                      boxShadow: `0 0 0 1px ${accent}`,
                                  }
                                : { borderColor: "hsl(var(--border))" }),
                            animationDelay: `${i * 60}ms`,
                        }}
                        data-testid={`fms-fit-${opt.value}`}
                    >
                        <div>
                            <div className="text-[15px] font-semibold text-foreground">{opt.label}</div>
                            <div className="text-[12px] text-muted-foreground mt-0.5">{opt.hint}</div>
                        </div>
                        <span
                            className="h-5 w-5 rounded-full border-2 grid place-items-center shrink-0 transition-all"
                            style={{
                                borderColor: selected ? accent : "hsl(var(--border))",
                                background: selected ? accent : "transparent",
                            }}
                        >
                            {selected && <Check className="h-3 w-3 text-white" strokeWidth={3} />}
                        </span>
                    </button>
                );
            })}
        </div>
    </div>
);
